export default __webpack_public_path__ + "static/media/Marketing Book Logo.f79e2b13.svg";